import React from "react";
import styles from "./Checkbox.module.scss";

type CheckboxProps = {
  children: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean, id?: number) => void;
  required?: boolean;
  id?: number;
  name: number;
};

const Checkbox: React.FC<CheckboxProps> = ({
  children,
  checked,
  onChange,
  required = false,
  name,
  id = name,
}) => {
  return (
    <label className={styles.checkboxContainer} htmlFor={String(id)}>
      <input
        required={required}
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          onChange(e.target.checked, id);
        }}
        className={styles.checkboxInput}
        name={String(name)}
        id={String(id)}
      />
      <span className={styles.customCheckbox}></span>
      <span className={styles.label}>{children}</span>
    </label>
  );
};

export default Checkbox;
